var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoUnits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65 2.00039C4.65 1.25481 5.25442 0.650391 6 0.650391H24C24.7456 0.650391 25.35 1.25481 25.35 2.00039V31.6504H30V32.3504H0V31.6504H4.65V2.00039ZM5.35 31.6504H24.65V2.00039C24.65 1.64141 24.359 1.35039 24 1.35039H6C5.64102 1.35039 5.35 1.64141 5.35 2.00039V31.6504Z",
    fill: "#807E8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0004 14.3504C19.0891 14.3504 18.3504 15.0891 18.3504 16.0004C18.3504 16.9117 19.0891 17.6504 20.0004 17.6504C20.9117 17.6504 21.6504 16.9117 21.6504 16.0004C21.6504 15.0891 20.9117 14.3504 20.0004 14.3504ZM17.6504 16.0004C17.6504 14.7025 18.7025 13.6504 20.0004 13.6504C21.2983 13.6504 22.3504 14.7025 22.3504 16.0004C22.3504 17.2983 21.2983 18.3504 20.0004 18.3504C18.7025 18.3504 17.6504 17.2983 17.6504 16.0004Z",
    fill: "#807E8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUnits);
export default __webpack_public_path__ + "static/media/no-units.16688b6a.svg";
export { ForwardRef as ReactComponent };